import { AnimatePresence } from 'motion/react';
import * as S from './CountdownStyles';

interface CountdownProps {
  /**
   * An integer to display in the countdown.
   */
  number: number;

  /**
   * DO NOT USE THIS PROP!
   * For indirect usage via styled-components only.
   */
  className?: string;
}

const Countdown = ({ number, className }: CountdownProps) => (
  <S.Container>
    <AnimatePresence>
      <S.Blob key={number} className={className}>
        <S.Span>{number.toString()}</S.Span>
      </S.Blob>
    </AnimatePresence>
  </S.Container>
);

export default Countdown;
